import styled from 'styled-components';

import { LocaleFragment } from '@lib/tools/locale/views/LocaleFragment';

export const InsertIntlJSXPart = ({ text, linkId, linkRender, className = '' }) => {
  const InsertIntlJSXPartWrapper = styled.div`
    display: inline;
    line-height: 18px;

    p {
      display: inline !important;
      margin: 0 !important;
    }
  `;

  const [initialPart = '', linkPart = '', finalPart = ''] = text ? text.split(`[linkTo=${linkId}]`) : '';

  return (
    <InsertIntlJSXPartWrapper className={className}>
      <LocaleFragment message={initialPart} />
      {initialPart && `${' '}`}
      {linkRender(linkPart)}
      {finalPart && `${' '}`}
      <LocaleFragment message={finalPart} />
    </InsertIntlJSXPartWrapper>
  );
};
